<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-video-camera`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 8h28a2 2 0 011.995 1.85L33 10v28a2 2 0 01-1.85 1.995L31 40H3a2 2 0 01-1.995-1.85L1 38V10a2 2 0 011.85-1.995L3 8h28H3zm26 4H5v24h24V12zm18 3.532v16.936c0 1.554-1.865 2.514-3.332 1.715L36 30V18l7.668-4.183c1.467-.8 3.332.16 3.332 1.715zm-4 3.533l-3 1.2v7.47l3 1.2v-9.87zM15 16v6H9v-6h6z"/></svg>
</template>
<script>

export default {
  name: 'IconVideoCamera',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
